import React from 'react';

import {AggState, checkTimeAggregationEnabled} from 'src/components/AggOptions';

/**
 * The state behind one chart's AggOptions. The cadence is clamped to what the controls allow for
 * the date range, derived rather than only corrected in an effect so the render that first sees
 * a long range never issues a request at a cadence the controls disable for it.
 */
export function useAggregation(
  dateRange: [Date, Date],
  initial: Pick<AggState, 'timeAggregation' | 'rateVolumeMode'>
): {aggregation: AggState; updateAggregation: (update: Partial<AggState>) => void} {
  const [state, updateAggregation] = React.useReducer(
    (current: AggState, update: Partial<AggState>) => ({...current, ...update}),
    {...initial, aggregationMethod: 'mean'}
  );
  const timeAggregation = checkTimeAggregationEnabled(
    state.timeAggregation,
    dateRange[0],
    dateRange[1]
  )
    ? state.timeAggregation
    : '1D';
  React.useEffect(() => {
    if (timeAggregation !== state.timeAggregation) updateAggregation({timeAggregation});
  }, [timeAggregation, state.timeAggregation]);
  const aggregation = React.useMemo(() => ({...state, timeAggregation}), [state, timeAggregation]);
  return {aggregation, updateAggregation};
}
